export default "__VITE_ASSET__0adfdc0e__"